<nb-card class="manager-card" [nbSpinner]="loading">
    <nb-card-header>
        <div class="header-row">
            <div class="header-title">
                <span>Gestion des emplacements personnalisés</span>
                <span *ngIf="firestoreStatus === 'ready'" class="firestore-status ready"
                    style="display: inline-flex; align-items: center; gap: 4px; font-size: 0.8rem; color: #00d68f; font-weight: 600;">
                    <nb-icon icon="checkmark-circle-2-outline"></nb-icon> Prêt
                </span>
                <span *ngIf="firestoreStatus === 'pending'" class="firestore-status pending"
                    style="display: inline-flex; align-items: center; gap: 4px; font-size: 0.8rem; color: #ffaa00; font-weight: 600;">
                    <nb-icon icon="loader-outline"></nb-icon> Chargement Firestore...
                </span>
            </div>
            <div class="header-actions">
                <button *ngIf="selectedImages.size > 0" nbButton status="danger" size="small"
                    [disabled]="firestoreStatus !== 'ready'"
                    [nbTooltip]="deleteButtonTooltip"
                    (click)="deleteSelected()">
                    <nb-icon icon="trash-2-outline"></nb-icon> Supprimer ({{ selectedImages.size }})
                </button>
                <div class="view-toggle">
                    <button nbButton size="small" [status]="viewMode === 'desk' ? 'primary' : 'basic'"
                        (click)="viewMode = 'desk'">
                        <nb-icon icon="monitor-outline"></nb-icon> Desktop
                    </button>
                    <button nbButton size="small" [status]="viewMode === 'mob' ? 'primary' : 'basic'"
                        (click)="viewMode = 'mob'">
                        <nb-icon icon="smartphone-outline"></nb-icon> Mobile
                    </button>
                </div>
                <button nbButton ghost size="small" (click)="close()">
                    <nb-icon icon="close-outline"></nb-icon>
                </button>
            </div>
        </div>

        <!-- Audience : compteur, filtre par segment email et export CSV vont ensemble -->
        <div class="audience-bar" *ngIf="totalPersonalizedUsers > 0 || firestoreStatus === 'ready'">
            <div class="audience-count"
                nbTooltip="Users avec une perso réelle (combo ≠ default) ET présents dans info-crm (opt-in actif). Identique au count du CSV téléchargeable.">
                <nb-icon icon="people-outline"></nb-icon>
                <strong>{{ displayedUserCount | number }}</strong>
                <span>utilisateurs personnalisables</span>
                <span class="audience-total" *ngIf="selectedSegments.length > 0">sur {{ totalPersonalizedUsers | number }}</span>
            </div>
            <div class="audience-actions">
                <nb-select *ngIf="loadingSegments || segmentOptions.length > 0" multiple size="small"
                    class="segment-select"
                    [(selected)]="selectedSegments" [disabled]="loadingSegments || exportingPersonalizableUsers"
                    [placeholder]="loadingSegments ? 'Chargement des segments…' : 'Tous les segments'"
                    nbTooltip="Filtre le compteur et le CSV par segment email">
                    <nb-option *ngFor="let segment of segmentOptions" [value]="segment.label"
                        [disabled]="segment.count === 0">
                        {{ segment.label }} ({{ segment.count | number }})
                    </nb-option>
                </nb-select>
                <button nbButton status="info" size="small" outline
                    [disabled]="firestoreStatus !== 'ready' || exportingPersonalizableUsers || (selectedSegments.length > 0 && displayedUserCount === 0)"
                    nbTooltip="Télécharge un CSV des NUMERO_CLIENT personnalisables (combo ≠ default + présents dans info-crm)"
                    (click)="exportPersonalizableUsers()">
                    <nb-icon [icon]="exportingPersonalizableUsers ? 'loader-outline' : 'download-outline'"></nb-icon>
                    {{ exportingPersonalizableUsers ? 'Génération…' : 'Segment personnalisable (CSV)' }}
                </button>
            </div>
        </div>
    </nb-card-header>
    <nb-card-body>
        <div *ngIf="firestoreStatus === 'syncing'" class="sync-banner"
            style="display: flex; align-items: center; gap: 10px; padding: 10px 14px; margin-bottom: 16px;
                   background: #fff4cc; border: 1px solid #ffc94d; border-radius: 4px; color: #8a6d1a;">
            <nb-icon icon="sync-outline" style="color: #d48806;"></nb-icon>
            <div style="font-size: 0.85rem;">
                <strong>Synchronisation en cours (~2 min)</strong> — L'aperçu utilisateur affichera l'ancien contenu
                jusqu'à la fin de la propagation. Un toast confirmera la fin.
            </div>
        </div>
        <div *ngIf="firestoreStatus === 'error'" class="sync-banner error"
            style="display: flex; align-items: center; gap: 10px; padding: 10px 14px; margin-bottom: 16px;
                   background: #ffd6d9; border: 1px solid #ff3d71; border-radius: 4px; color: #9c2a3e;">
            <nb-icon icon="alert-triangle-outline" style="color: #ff3d71;"></nb-icon>
            <div style="font-size: 0.85rem;">
                <strong>Erreur de synchronisation</strong> — Veuillez contacter votre chargé de compte.
            </div>
        </div>
        <div *ngIf="images.length > 0; else noImages">

            <!-- SECTION 1: SLOTS DE BASE (Read Only) -->
            <h6 class="section-title">Slots de base (Non modifiable)</h6>
            <div class="images-grid mb-4">
                <div class="image-item base-slot" *ngFor="let img of baseImagesWithSlots; let i = index">
                    <div class="slot-badge">Slot {{ i + 1 }}</div>
                    <img [src]="viewMode === 'desk' ? img.display_url_desk : img.display_url_mob" alt="Product Image"
                        (click)="openPreview(viewMode === 'desk' ? img.display_url_desk : img.display_url_mob)"
                        style="cursor: pointer;">
                    <div class="actions"
                        style="display: flex; justify-content: flex-end; align-items: center; padding: 0 10px;">
                        <a nbButton status="info" size="small" [href]="img.link" target="_blank">
                            <nb-icon icon="external-link-outline"></nb-icon>
                        </a>
                    </div>
                </div>
            </div>

            <!-- SECTION 2: PRODUITS ÉLIGIBLES (Manageable) -->
            <div style="display: flex; justify-content: space-between; align-items: flex-start; gap: 10px; margin-bottom: 15px; flex-wrap: wrap;">
                <h6 class="section-title" style="margin: 0;">Produits éligibles (Réserve)</h6>
                <div style="display: flex; flex-wrap: wrap; gap: 5px; justify-content: flex-end; flex: 1; min-width: 0;" *ngIf="slotCount > 1">
                    <button *ngFor="let tab of slotTabs" nbButton size="tiny"
                        [status]="selectedSlotTabIndex === tab ? 'info' : 'basic'" (click)="selectedSlotTabIndex = tab">
                        Aperçu Slot {{ tab }}
                    </button>
                </div>
            </div>
            <div class="images-grid">
                <div class="image-item reserve-slot" *ngFor="let img of reserveImagesForSelectedSlot; let i = index">

                    <!-- Checkbox top-right -->
                    <div class="checkbox-container">
                        <nb-checkbox [checked]="selectedImages.has(img.id)"
                            (checkedChange)="toggleSelection(img.id)"></nb-checkbox>
                    </div>

                    <img [src]="viewMode === 'desk' ? img.display_url_desk : img.display_url_mob" alt="Product Image"
                        (click)="openPreview(viewMode === 'desk' ? img.display_url_desk : img.display_url_mob)"
                        style="cursor: pointer;">

                    <div class="actions"
                        style="display: flex; justify-content: space-between; align-items: center; padding: 0 10px;">
                        <span style="color: #ff3d71; font-weight: bold; font-size: 0.85rem;"
                            *ngIf="img.display_user_count !== undefined">
                            {{ img.display_user_count | number }} users
                        </span>
                        <a nbButton status="info" size="small" [href]="img.link" target="_blank">
                            <nb-icon icon="external-link-outline"></nb-icon>
                        </a>
                    </div>
                </div>
            </div>

        </div>
        <ng-template #noImages>
            <div [style.min-height.px]="loading ? 200 : 0"
                style="display: flex; flex-direction: column; justify-content: center; align-items: center; gap: 15px;">
                <p class="empty-state" *ngIf="!loading" style="margin: 0;">Aucune image dynamique trouvée pour cet
                    email.</p>
                <p class="empty-state" *ngIf="loading" style="margin: 0; color: #8f9bb3; font-style: italic;">
                    Chargement des blocs dynamiques en cours...
                </p>
            </div>
        </ng-template>

        <!-- Delete Confirmation Dialog -->
        <ng-template #deleteDialog let-ref="dialogRef">
            <nb-card>
                <nb-card-body>
                    Voulez-vous vraiment supprimer <strong>{{ selectedImages.size }}</strong> images du pool de réserve
                    ?
                </nb-card-body>
                <nb-card-footer>
                    <div class="row">
                        <div class="col text-center">
                            <button nbButton status="danger" (click)="ref.close()"
                                style="margin-right: 10px;">Non</button>
                            <button nbButton status="success" (click)="confirmDelete(ref)">Oui</button>
                        </div>
                    </div>
                </nb-card-footer>
            </nb-card>
        </ng-template>

        <!-- Image Preview Dialog -->
        <ng-template #previewDialog let-ref="dialogRef">
            <nb-card style="max-width: 90vw; max-height: 90vh;">
                <nb-card-body
                    style="padding: 0; display: flex; justify-content: center; align-items: center; background: #000;">
                    <img [src]="previewUrl" style="max-width: 100%; max-height: 85vh; object-fit: contain;">
                    <button nbButton ghost status="control" size="large" (click)="ref.close()"
                        style="position: absolute; top: 10px; right: 10px; z-index: 100;">
                        <nb-icon icon="close-outline"></nb-icon>
                    </button>
                </nb-card-body>
            </nb-card>
        </ng-template>
    </nb-card-body>
</nb-card>